// API Configuration - connects frontend to backend
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

console.log('🔧🔧🔧 API_BASE_URL configured as:', API_BASE_URL);
console.log('⏰ Loaded at:', new Date().toISOString());

export default API_BASE_URL;
